import React from 'react'
import PropTypes from 'prop-types'

class HorizontalScroll extends React.Component {
  constructor (props) {
    super(props)

    this.scrollContent = React.createRef()
    this.scrollContainer = React.createRef()
    this.handleOnWheel = this.handleOnWheel.bind(this)
    this.scrollNeeded = this.scrollNeeded.bind(this)
    this.xPos = 0
  }

  componentDidMount () {
    this.overflowDistance =
      this.scrollContent.current.clientWidth -
      this.scrollContainer.current.clientWidth
  }

  handleOnWheel (e) {
    if (this.scrollNeeded()) {
      e.preventDefault()

      // Positive deltaY scrolls element to right
      const newXPos = this.xPos + e.deltaY
      const translatingRight = e.deltaY > 0
      this.xPos = translatingRight
        ? Math.min(0, newXPos)
        : Math.max(-this.overflowDistance, newXPos)
      this.scrollContent.current.style.transform = `translateX(${this.xPos}px)`
    }
  }

  scrollNeeded () {
    return this.overflowDistance > 0
  }

  render () {
    const containerStyle = {
      overflow: 'hidden'
    }

    if (this.scrollNeeded()) {
      containerStyle.WebkitMaskImage =
        'linear-gradient(to right, #000000 92%, transparent 100%)'
    }

    const contentStyle = {
      display: 'inline-block',
      minWidth: '100%'
    }

    return (
      <div
        style={containerStyle}
        onWheel={this.handleOnWheel}
        ref={this.scrollContainer}
      >
        <div ref={this.scrollContent} style={contentStyle}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

HorizontalScroll.propTypes = {
  children: PropTypes.node
}

export default HorizontalScroll
